"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListData = void 0;
// ----------- import Packs
var react_1 = __importDefault(require("react"));
// ----------- import Internals
var react_native_1 = require("react-native");
// ----------- export Component
var ListData = function (_a) {
    var idsArr = _a.idsArr, listCBFn = _a.listCBFn, type = _a.type, cols = _a.cols;
    // ----------- set Array of String Ids
    var condArr = Array.isArray(idsArr) && idsArr;
    if (!condArr)
        return showError().noArr();
    // ----------- set Render No Item Component
    var isEmpty = condArr.length === 0;
    if (isEmpty)
        return listCBFn('', true);
    // ----------- set Error if is not an String Array
    var condItemStr = !isEmpty && typeof condArr[0] !== 'string';
    if (condItemStr)
        return showError().noStr();
    // ----------- set a CallBack to Render Each Item
    var renderItem = function (_a) {
        var item = _a.item;
        return react_1["default"].createElement(react_1["default"].Fragment, null, listCBFn(item, false));
    };
    // ----------- set Conditionals
    var condType = type === 'horizontal' ? true : false;
    // ----------- set Return
    return (react_1["default"].createElement(react_native_1.FlatList, { data: idsArr, renderItem: renderItem, horizontal: condType, numColumns: cols, keyExtractor: function (item) { return item; } }));
};
exports.ListData = ListData;
// ----------- set Helper
var showError = function () {
    var msgBase = 'Envie um array de strings de ids pro UseList! Você pode usar o INIT DATA pra preparar esse array!';
    var noArr = function () {
        var msgNoArr = "N\u00E3o \u00E9 ARRAY!\n          " + msgBase;
        throw new Error(msgNoArr);
    };
    var noStr = function () {
        var msgNoStr = "N\u00E3o \u00E9 um ARRAY com STRINGS!\n      " + msgBase;
        throw new Error(msgNoStr);
    };
    return { noArr: noArr, noStr: noStr };
};
